import { useMediaQuery, useTheme } from '@mui/material'
import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'

import useStyles from './index.styles'

interface IProps {
  text: string
  query: string
  colorHighlight?: boolean
  isDeactivated?: boolean
}

const HighlightText = (props: IProps) => {
  const { text, query, colorHighlight, isDeactivated } = props

  const classes = useStyles
  const theme = useTheme()
  const primaryMatches = match(text || '', query, { insideWords: true })
  const primaryParts = parse(text || '', primaryMatches)
  const primaryHasMatch = primaryParts.find((part) => part.highlight)
  const regex = / /g

  const smallScreenMatches = useMediaQuery(() => theme.breakpoints.down('sm'))

  return (
    <>
      {primaryParts.map((part, idx) => (
        <span
          key={idx}
          style={{
            ...(colorHighlight && primaryHasMatch && part.highlight ? classes.highlightColor(theme) : {}),
            ...(primaryHasMatch && part.highlight ? classes.highlightBold : {}),
            ...(isDeactivated ? classes.isDeactivatedText : {}),
            ...(smallScreenMatches ? classes.truncatedResult : {}),
          }}
        >
          {part.text.replace(regex, '\u00a0\u200B')}
          {/* The highlighting strips out spaces, so we replace them with non-breaking (&nbsp;) spaces. \u00a0 is the non-breaking space, while u200B allows the line to break and wrap if the content doesn't fit on one line */}
        </span>
      ))}
    </>
  )
}

export default HighlightText
